// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3xyli","containerItemsCenter":"Skeleton_containerItemsCenter__314Cd"};